import React from 'react';
import { translate } from 'react-i18next';


const CommunicationDetails = (props) => {
  const { details, t } = props;

  return (details && (details.sms || details.push || details.email) ?
    <div className="confirm-section">
      <p className="caption">{t('communication')}</p>

      {details.sms || details.push || details.email ?
        <div className="row">
          <p className="label">{t('nj_message_type')}</p>
          <p>
            {details.sms ? <span className="type">{t('nj_mass_message_type_sms')}</span> : null}
            {details.push ? <span className="type">{t('nj_mass_message_type_push')}</span> : null}
            {details.email ? <span className="type">{t('nj_mass_message_type_email')}</span> : null}
          </p>
        </div>
        : null
      }

      {/* ──── SMS ─────────────────────────────────────────────────────────────────────────────── */}
      {details.sms && details.smsMessage ?
        <div className="info-block">
          <div className="row">
            <p className="label">{t('nj_mass_message_sms_text')}</p>
            <p>{details.smsMessage}</p>
          </div>
        </div>
        : null
      }

      {/* ──── Push ────────────────────────────────────────────────────────────────────────────── */}
      {details.push ?
        <div className="info-block">
          {details.pushTitle ?
            <div className="row">
              <p className="label">{t('nj_mass_message_push_title')}</p>
              <p>{details.pushTitle}</p>
            </div>
            : null
          }

          {details.pushMessage ?
            <div className="row">
              <p className="label">{t('nj_mass_message_push_message')}</p>
              <p>{details.pushMessage}</p>
            </div>
            : null
          }
        </div>
        : null
      }
    </div>
    : null
  );
};

export default translate()(CommunicationDetails);
